import * as allTokens from '@cof/fs-tokens/lib/js/fs-tokens.override';
/**
 * Takes a token name from FS tokens and returns an overridable token
 * object utilizing that custom property name and the token's default value
 */
export const useToken = (tokenName) => {
    if (!allTokens[tokenName]) {
        throw new TypeError(`FS Tokens does not export a token named ${tokenName}.`);
    }
    return `var(${allTokens[tokenName].fs}, ${allTokens[tokenName].value})`;
};
//# sourceMappingURL=use-token.js.map